import globalCss from '../../../css/global.module.scss';
import classNames from 'classnames';
import { CaseProps } from './Case.type';

const Case = ({ ariaLabel, caseType, children }: CaseProps) => {
    return (
        <p aria-label={ariaLabel} className={classNames(globalCss[caseType], globalCss.inlineBlock)}>
            {children}
        </p >
    );
};

export default Case;